"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groups.loading_groups': 'Cargando grupos...',
    'whatsapp.groups.selectNumber': 'Número de teléfono',
    'whatsapp.groups.selectNumberPlaceholder': 'Seleccionar número de teléfono...',
    'whatsapp.groups.loadFailed': 'Error al cargar los grupos de WhatsApp.',
    'whatsapp.groups.noGroups': 'No se encontraron grupos.',
    'whatsapp.groups.trackingOn': 'Rastreando',
    'whatsapp.groups.trackingOff': 'Sin rastreo',
    'whatsapp.groups.loading': 'Cargando...',
    'whatsapp.groups.notFound': 'Grupo no encontrado.',
    'whatsapp.groups.info': 'Información del grupo',
    'whatsapp.groups.name': 'Nombre',
    'whatsapp.groups.waId': 'ID de WhatsApp',
    'whatsapp.groups.phone': 'Número de teléfono',
    'whatsapp.groups.tracking': 'Habilitar rastreo de mensajes',
    'whatsapp.groups.pinMessage.label': 'Mensaje fijado',
    'whatsapp.groups.pinMessage.placeholder': 'Contenido del mensaje que se fijará en el grupo...',
    'whatsapp.groups.pinMessage.hint': 'Con el seguimiento activado y el bot como administrador, este mensaje se fijará.',
    'whatsapp.groups.pinReminder.label': 'Reenviar mensaje fijado',
    'whatsapp.groups.pinReminder.intervalLabel': 'Intervalo (horas)',
    'whatsapp.groups.pinReminder.hint': 'Reenvía el mensaje fijado cuando hayan llegado al menos 10 mensajes nuevos desde el último recordatorio.',
    'whatsapp.groups.tracking.badge': 'Rastreado',
    'whatsapp.groups.communicationType.wa': 'WA',
    'whatsapp.groups.communicationType.tele': 'TELE',
    'whatsapp.groups.teleId': 'ID de Telegram',
    'whatsapp.groups.trackingEnabled': 'Rastreo de mensajes habilitado.',
    'whatsapp.groups.trackingDisabled': 'Rastreo de mensajes deshabilitado.',
    'whatsapp.groups.trackingFailed': 'Error al actualizar la configuración de rastreo.',
    'whatsapp.groups.messages': 'Mensajes rastreados',
    'whatsapp.groups.noMessages': 'Aún no hay mensajes rastreados.',
    'whatsapp.groups.openGroup': 'Abrir grupo',
    'whatsapp.groups.back': 'Volver',
    'whatsapp.groups.copyUrl.label': 'Copiar enlace público',
    'whatsapp.groups.copyUrl.copied': '¡Copiado!',
    'whatsapp.groups.copyUrl.title': 'Copiar un enlace público a este grupo (con filtro opcional de número de teléfono)',
    'whatsapp.groups.copyUrl.success': 'Enlace público copiado al portapapeles.',
    'whatsapp.groups.copyUrl.failed': 'No se pudo copiar el enlace público.',
    'whatsapp.groups.botSettings': 'Configuración del bot',
    'whatsapp.groups.avatar': 'Avatar',
    'whatsapp.groups.selectAvatar': '-- Seleccionar avatar --',
    'whatsapp.groups.botInstruction': 'Instrucción del bot',
    'whatsapp.groups.botInstructionPlaceholder': 'Ingrese instrucciones para el bot de WhatsApp...',
    'whatsapp.groups.saveSettings': 'Guardar configuración',
    'whatsapp.groups.settingsSaved': 'Configuración guardada correctamente.',
    'whatsapp.groups.settingsFailed': 'Error al guardar la configuración.',
    'whatsapp.groups.listTitle': 'Grupos de WhatsApp',
    'whatsapp.groups.addGroup': 'Agregar grupo',
    'whatsapp.groups.announce.label': 'Todos los usuarios pueden escribir en el grupo',
    'whatsapp.groups.announce.hint': 'Cuando está activado, todos los miembros del grupo pueden enviar mensajes (no solo los admins).',
    'whatsapp.groups.announce.saved': 'Modo anuncio actualizado.',
    'whatsapp.groups.announce.failed': 'Error al actualizar el modo anuncio.',
    'whatsapp.groups.remoteAccess.label': 'Acceso remoto',
    'whatsapp.groups.accessPassword.label': 'Contraseña de acceso',
    'whatsapp.groups.security.save': 'Establecer seguridad',
    'whatsapp.groups.security.saved': 'Configuración de seguridad guardada.',
    'whatsapp.groups.security.failed': 'Error al guardar la configuración de seguridad.',
    'whatsapp.groups.gate.title': 'Acceso al grupo',
    'whatsapp.groups.gate.password': 'Contraseña',
    'whatsapp.groups.gate.submit': 'Entrar',
    'whatsapp.groups.gate.error': 'Contraseña incorrecta. Por favor, inténtelo de nuevo.',
    'whatsapp.groups.gate.notAllowed': 'Este grupo no está disponible para el número de teléfono seleccionado.',
    'whatsapp.groups.dateFrom': 'Desde',
    'whatsapp.groups.dateTo': 'Hasta',
    'whatsapp.groups.summarize': 'Resumir',
    'whatsapp.groups.summary': 'Resumen',
    'whatsapp.groups.summaries.title': 'Resúmenes',
    'whatsapp.groups.summaries.empty': 'Sin resúmenes aún.',
    'whatsapp.groups.summaries.date': 'Fecha',
    'whatsapp.groups.summaries.view': 'Ver',
    'whatsapp.groups.summaries.excerpt': 'Resumen',
    'whatsapp.groups.summaries.modalTitle': 'Detalles del resumen',
    'whatsapp.groups.summarizeDone': 'Resumen generado correctamente.',
    'whatsapp.groups.summarizeFailed': 'Error al generar el resumen.',
    'whatsapp.groups.syncMessages.button': 'Sincronizar mensajes',
    'whatsapp.groups.syncMessages.done': 'Mensajes sincronizados correctamente.',
    'whatsapp.groups.sendMessage.title': 'Enviar mensaje',
    'whatsapp.groups.sendMessage.placeholder': 'Escribe un mensaje para enviar al grupo...',
    'whatsapp.groups.sendMessage.send': 'Enviar',
    'whatsapp.groups.sendMessage.success': 'Mensaje enviado.',
    'whatsapp.groups.sendMessage.failed': 'No se pudo enviar el mensaje.',
    'whatsapp.groups.trackingDisabledHint': 'El seguimiento está desactivado para este grupo. Active el seguimiento para ver mensajes, enviar mensajes y ver resúmenes.',
    'whatsapp.groups.syncMessages.failed': 'Error al sincronizar los mensajes.',
    'whatsapp.groups.media.download': 'Descargar',
    'whatsapp.groups.media.downloading': 'Descargando...',
    'whatsapp.groups.media.downloadFailed': 'Error al descargar el archivo multimedia.',
    'whatsapp.groups.media.attachment': 'Adjunto',
    'whatsapp.groups.agentChecking': 'Verificando el estado del agente de WhatsApp...',
    'whatsapp.groups.agentOffline': 'El agente de WhatsApp está desconectado. Todas las acciones que requieren conexión al agente están deshabilitadas.',
    'whatsapp.groups.members.title': 'Miembros del grupo',
    'whatsapp.groups.members.sync': 'Sincronizar',
    'whatsapp.groups.members.syncFailed': 'Error al sincronizar miembros.',
    'whatsapp.groups.members.empty': 'Sin miembros. Haz clic en Sincronizar para cargar desde WhatsApp.',
    'whatsapp.groups.members.phone': 'Teléfono',
    'whatsapp.groups.members.id': 'WA ID',
    'whatsapp.groups.members.name': 'Nombre',
    'whatsapp.groups.members.role': 'Rol',
    'whatsapp.groups.members.superAdmin': 'Super Admin',
    'whatsapp.groups.members.admin': 'Admin',
    'whatsapp.groups.members.member': 'Miembro',
    'whatsapp.groups.members.promote': 'Promover a admin',
    'whatsapp.groups.members.promoted': 'Miembro promovido a admin.',
    'whatsapp.groups.members.promoteFailed': 'Error al promover miembro.',
    'whatsapp.groups.addParticipants.title': 'Agregar participantes',
    'whatsapp.groups.addParticipants.phonePlaceholder': 'Ingrese número de teléfono...',
    'whatsapp.groups.addParticipants.addPhone': 'Agregar número',
    'whatsapp.groups.addParticipants.noPhonesYet': 'Aún no se han agregado números de teléfono.',
    'whatsapp.groups.addParticipants.submit': 'Agregar participantes',
    'whatsapp.groups.addParticipants.success': 'Participantes agregados exitosamente.',
    'whatsapp.groups.addParticipants.failed': 'Error al agregar participantes.',
    'whatsapp.groups.members.remove': 'Eliminar',
    'whatsapp.groups.members.removed': 'Miembro eliminado del grupo.',
    'whatsapp.groups.members.removeFailed': 'Error al eliminar miembro.',
    'whatsapp.groups.members.feedBotData': 'Datos para el bot',
    'whatsapp.groups.members.allowBotUsage': 'Permitir uso del bot',
    'whatsapp.groups.members.updateFailed': 'Error al actualizar la configuración del miembro.',
    'whatsapp.groups.joinGroup': 'Unirse al grupo',
    'whatsapp.groups.joinLink.modalTitle': 'Unirse al grupo de WhatsApp',
    'whatsapp.groups.joinLink.hint': 'Pega un enlace de invitación de grupo de WhatsApp (p. ej. https://chat.whatsapp.com/...) y el agente se unirá al grupo.',
    'whatsapp.groups.joinLink.label': 'Enlace de invitación',
    'whatsapp.groups.joinLink.placeholder': 'https://chat.whatsapp.com/...',
    'whatsapp.groups.joinLink.required': 'Por favor ingresa un enlace de invitación.',
    'whatsapp.groups.joinLink.submit': 'Unirse',
    'whatsapp.groups.joinLink.cancel': 'Cancelar',
    'whatsapp.groups.joinLink.success': 'Te uniste al grupo exitosamente.',
    'whatsapp.groups.joinLink.failed': 'No se pudo unir al grupo.',
    'whatsapp.groups.trackLogs': 'Registro de actividad',
    'whatsapp.groups.trackLogs.noLogs': 'Aún no hay registros de actividad.',
    'whatsapp.groups.trackLogs.logType.neutral': 'Neutral',
    'whatsapp.groups.trackLogs.logType.good': 'Bueno',
    'whatsapp.groups.trackLogs.logType.warning': 'Advertencia',
    'whatsapp.groups.trackLogs.logType.critical': 'Crítico',
};
